import styles from './.FilterBoxComponents.module.css';

const NameFilter = ( {firstName, setFirstName, lastName, setLastName}) => {
    
    return ( 
<div className={styles.accordionContent}>
{/* Content to display when accordion is open */}
    <label>First Name</label>
    <input type="text" aria-label='First Name' className={styles.filterInput} value={firstName} onChange={(e) => setFirstName(e.target.value)}/>
    <label>Last Name</label>
    <input type="text" aria-label='First Name' className={styles.filterInput} value={lastName} onChange={(e) => setLastName(e.target.value)}/>
</div> 
    );
}
 
export default NameFilter;